if (!customElements.get('wls-section-autoscroll')) {
  class WLSSectionAutoscroll extends HTMLElement {
    constructor() {
      super();
      this._onClick = this._onClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }

    /**
     * @param {MouseEvent} e
     */
    _onClick(e) {
      const btn = e.target.closest('button');
      if (!btn || !this.contains(btn)) return;

      e.preventDefault();

      const sectionRoot =
        btn.closest('.shopify-section') ||
        btn.closest('section[id^="shopify-section-"]') ||
        btn.closest('[id^="shopify-section-"]');

      if (sectionRoot) {
        const next = sectionRoot.nextElementSibling;
        if (next instanceof HTMLElement) {
          next.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        const y = sectionRoot.getBoundingClientRect().bottom + window.scrollY;
        window.scrollTo({ top: y, behavior: 'smooth' });
        return;
      }

      const anchor = btn.closest('[class*="wls-"]') || btn.parentElement;
      if (anchor instanceof HTMLElement) {
        const y = anchor.getBoundingClientRect().bottom + window.scrollY;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  }

  customElements.define('wls-section-autoscroll', WLSSectionAutoscroll);
}
